function normalizeTailnetDnsSuffix(value?: string): string | null {
  const suffix = value?.trim().replace(/^\./, '').toLowerCase()
  return suffix ? `.${suffix}` : null
}

export function isTailnetHost(hostname: string, suffix?: string): boolean {
  const normalizedSuffix = normalizeTailnetDnsSuffix(suffix)
  return normalizedSuffix !== null && hostname.toLowerCase().endsWith(normalizedSuffix)
}
